module.exports = {
  "en_US": [
    {
      "name": "Latest",
      "order": 1,
      "short_code": "a",
      "sub_keyword": [
        {
          "name": "Grand Opening",
          "order": 1,
          "short_code": "a1"
        },
        {
          "name": "New Release",
          "order": 2,
          "short_code": "a2"
        },
        {
          "name": "New Product",
          "order": 3,
          "short_code": "a3"
        },
        {
          "name": "New Service",
          "order": 4,
          "short_code": "a4"
        },
        {
          "name": "New Class",
          "order": 5,
          "short_code": "a5"
        },
        {
          "name": "Other",
          "order": 6,
          "short_code": "aor"
        }
      ]
    },
    {
      "name": "Free",
      "order": 2,
      "short_code": "b",
      "sub_keyword": [
        {
          "name": "Lottery",
          "order": 1,
          "short_code": "b1"
        },
        {
          "name": "Free Admission",
          "order": 2,
          "short_code": "b2"
        },
        {
          "name": "Free Sample",
          "order": 3,
          "short_code": "b3"
        },
        {
          "name": "Free Gift",
          "order": 4,
          "short_code": "b4"
        },
        {
          "name": "Free Trial",
          "order": 5,
          "short_code": "b5"
        },
        {
          "name": "Free Demo",
          "order": 6,
          "short_code": "b6"
        },
        {
          "name": "Free Lesson",
          "order": 7,
          "short_code": "b7"
        },
        {
          "name": "Free Tasting",
          "order": 8,
          "short_code": "b8"
        },
        {
          "name": "Free Watch",
          "order": 10,
          "short_code": "b10"
        },
        {
          "name": "Free Borrow",
          "order": 11,
          "short_code": "b11"
        },
        {
          "name": "Other",
          "order": 12,
          "short_code": "bor"
        }
      ]
    },
    {
      "name": "Promotion",
      "order": 3,
      "short_code": "c",
      "sub_keyword": [
        {
          "name": "On Sale",
          "order": 1,
          "short_code": "c1"
        },
        {
          "name": "Special Sale",
          "order": 2,
          "short_code": "c2"
        },
        {
          "name": "Limited Time",
          "order": 3,
          "short_code": "c3"
        },
        {
          "name": "Flash Sale",
          "order": 4,
          "short_code": "c4"
        },
        {
          "name": "Warehouse Sale",
          "order": 5,
          "short_code": "c5"
        },
        {
          "name": "Closing Sale",
          "order": 6,
          "short_code": "c6"
        },
        {
          "name": "Clearance Sale",
          "order": 7,
          "short_code": "c7"
        },
        {
          "name": "Bundle Sale",
          "order": 8,
          "short_code": "c8"
        },
        {
          "name": "X% Off",
          "order": 9,
          "short_code": "c9"
        },
        {
          "name": "Auction",
          "order": 10,
          "short_code": "c10"
        },
        {
          "name": "Other",
          "order": 11,
          "short_code": "cor"
        }
      ]
    },
    {
      "name": "Sale Discount",
      "order": 4,
      "short_code": "d",
      "sub_keyword": [
        {
          "name": "Buy X get Y free",
          "order": 1,
          "short_code": "d1"
        },
        {
          "name": "$X Off $Y",
          "order": 2,
          "short_code": "d2"
        },
        {
          "name": "Buy $X get $Y cash coupon",
          "order": 3,
          "short_code": "d3"
        },
        {
          "name": "Buy $X get $Y digital coupon",
          "order": 4,
          "short_code": "d4"
        },
        {
          "name": "Discount for X persons",
          "order": 5,
          "short_code": "d5"
        },
        {
          "name": "Other",
          "order": 6,
          "short_code": "dor"
        }
      ]
    },
    {
      "name": "Direct Delivery",
      "order": 5,
      "short_code": "e",
      "sub_keyword": [
        {
          "name": "Fresh Direct Delivery",
          "order": 1,
          "short_code": "e1"
        },
        {
          "name": "Japan Direct Delivery",
          "order": 2,
          "short_code": "e2"
        },
        {
          "name": "Korea Direct Delivery",
          "order": 3,
          "short_code": "e3"
        },
        {
          "name": "Europe Direct Delivery",
          "order": 4,
          "short_code": "e4"
        },
        {
          "name": "UK Direct Delivery",
          "order": 5,
          "short_code": "e5"
        },
        {
          "name": "Germany Direct Delivery",
          "order": 6,
          "short_code": "e6"
        },
        {
          "name": "France Direct Delivery",
          "order": 7,
          "short_code": "e7"
        },
        {
          "name": "U.S. Direct Delivery",
          "order": 8,
          "short_code": "e8"
        },
        {
          "name": "Canada Direct Delivery",
          "order": 9,
          "short_code": "e9"
        },
        {
          "name": "New Zealand Direct Delivery",
          "order": 10,
          "short_code": "e10"
        },
        {
          "name": "Australia Direct Delivery",
          "order": 11,
          "short_code": "e11"
        },
        {
          "name": "Taiwan Direct Delivery",
          "order": 12,
          "short_code": "e12"
        },
        {
          "name": "Other",
          "order": 13,
          "short_code": "eor"
        }
      ]
    },
    {
      "name": "Festival Offer",
      "order": 6,
      "short_code": "f",
      "sub_keyword": [
        {
          "name": "Birthday Offer",
          "order": 1,
          "short_code": "f1"
        },
        {
          "name": "Anniversary Offer",
          "order": 2,
          "short_code": "f2"
        },
        {
          "name": "New Year Offer",
          "order": 3,
          "short_code": "f3"
        },
        {
          "name": "Valentine's Day Offer",
          "order": 4,
          "short_code": "f4"
        },
        {
          "name": "Easter Offer",
          "order": 5,
          "short_code": "f5"
        },
        {
          "name": "Mother's Day Offer",
          "order": 6,
          "short_code": "f6"
        },
        {
          "name": "Father's Day Offer",
          "order": 7,
          "short_code": "f7"
        },
        {
          "name": "Summer Offer",
          "order": 8,
          "short_code": "f8"
        },
        {
          "name": "Back to School",
          "order": 9,
          "short_code": "f9"
        },
        {
          "name": "Mid-Autumn Festival Offer",
          "order": 10,
          "short_code": "f10"
        },
        {
          "name": "Halloween Offer",
          "order": 11,
          "short_code": "f11"
        },
        {
          "name": "Thanksgiving Day",
          "order": 12,
          "short_code": "f12"
        },
        {
          "name": "Black Friday",
          "order": 13,
          "short_code": "f13"
        },
        {
          "name": "Christmas Offer",
          "order": 14,
          "short_code": "f14"
        },
        {
          "name": "Boxing Day",
          "order": 15,
          "short_code": "f15"
        },
        {
          "name": "Other",
          "order": 16,
          "short_code": "for"
        }
      ]
    },
    {
      "name": "Company Offer",
      "order": 7,
      "short_code": "g",
      "sub_keyword": [
        {
          "name": "Member Benefit",
          "order": 1,
          "short_code": "g1"
        },
        {
          "name": "Welcome Offer",
          "order": 2,
          "short_code": "g2"
        },
        {
          "name": "Other",
          "order": 3,
          "short_code": "gor"
        }
      ]
    },
    {
      "name": "Other",
      "order": 8,
      "short_code": "h",
      "sub_keyword": [
        {
          "name": "Wholesale",
          "order": 1,
          "short_code": "h1"
        },
        {
          "name": "Crossover",
          "order": 2,
          "short_code": "h2"
        },
        {
          "name": "Exclusive",
          "order": 3,
          "short_code": "h3"
        },
        {
          "name": "Limited Edition",
          "order": 4,
          "short_code": "h4"
        },
        {
          "name": "Special Edition",
          "order": 5,
          "short_code": "h5"
        },
        {
          "name": "Original",
          "order": 6,
          "short_code": "h6"
        },
        {
          "name": "Handmade",
          "order": 7,
          "short_code": "h7"
        },
        {
          "name": "Start-up",
          "order": 8,
          "short_code": "h8"
        },
        {
          "name": "Pre-Order",
          "order": 9,
          "short_code": "h9"
        },
        {
          "name": "Other",
          "order": 10,
          "short_code": "hor"
        }
      ]
    }
  ],
  "zh_HK": [
    {
      "name": "最新",
      "order": 1,
      "short_code": "a",
      "sub_keyword": [
        {
          "name": "新開張",
          "order": 1,
          "short_code": "a1"
        },
        {
          "name": "新推出",
          "order": 2,
          "short_code": "a2"
        },
        {
          "name": "新產品",
          "order": 3,
          "short_code": "a3"
        },
        {
          "name": "新服務",
          "order": 4,
          "short_code": "a4"
        },
        {
          "name": "新課程",
          "order": 5,
          "short_code": "a5"
        },
        {
          "name": "其他",
          "order": 6,
          "short_code": "aor"
        }
      ]
    },
    {
      "name": "免費",
      "order": 2,
      "short_code": "b",
      "sub_keyword": [
        {
          "name": "抽獎",
          "order": 1,
          "short_code": "b1"
        },
        {
          "name": "免費入場",
          "order": 2,
          "short_code": "b2"
        },
        {
          "name": "免費樣品",
          "order": 3,
          "short_code": "b3"
        },
        {
          "name": "免費贈送",
          "order": 4,
          "short_code": "b4"
        },
        {
          "name": "免費試用",
          "order": 5,
          "short_code": "b5"
        },
        {
          "name": "免費試玩",
          "order": 6,
          "short_code": "b6"
        },
        {
          "name": "免費試堂",
          "order": 7,
          "short_code": "b7"
        },
        {
          "name": "免費試食",
          "order": 8,
          "short_code": "b8"
        },
        {
          "name": "免費觀看",
          "order": 10,
          "short_code": "b10"
        },
        {
          "name": "免費借用",
          "order": 11,
          "short_code": "b11"
        },
        {
          "name": "其他",
          "order": 12,
          "short_code": "bor"
        }
      ]
    },
    {
      "name": "促銷",
      "order": 3,
      "short_code": "c",
      "sub_keyword": [
        {
          "name": "特價",
          "order": 1,
          "short_code": "c1"
        },
        {
          "name": "精選優惠",
          "order": 2,
          "short_code": "c2"
        },
        {
          "name": "期間限定",
          "order": 3,
          "short_code": "c3"
        },
        {
          "name": "限時搶購",
          "order": 4,
          "short_code": "c4"
        },
        {
          "name": "開倉",
          "order": 5,
          "short_code": "c5"
        },
        {
          "name": "结業清貨",
          "order": 6,
          "short_code": "c6"
        },
        {
          "name": "清貨減價",
          "order": 7,
          "short_code": "c7"
        },
        {
          "name": "捆綁優惠",
          "order": 8,
          "short_code": "c8"
        },
        {
          "name": "X折扣",
          "order": 9,
          "short_code": "c9"
        },
        {
          "name": "拍賣",
          "order": 10,
          "short_code": "c10"
        },
        {
          "name": "其他",
          "order": 11,
          "short_code": "cor"
        }
      ]
    },
    {
      "name": "消費優惠",
      "order": 4,
      "short_code": "d",
      "sub_keyword": [
        {
          "name": "買X送Y",
          "order": 1,
          "short_code": "d1"
        },
        {
          "name": "買滿 $X 即減 $Y",
          "order": 2,
          "short_code": "d2"
        },
        {
          "name": "買滿 $X 即送 $Y 現金卷",
          "order": 3,
          "short_code": "d3"
        },
        {
          "name": "買滿 $X 即送 $Y 電子優惠卷",
          "order": 4,
          "short_code": "d4"
        },
        {
          "name": "X人同行優惠",
          "order": 5,
          "short_code": "d5"
        },
        {
          "name": "其他",
          "order": 6,
          "short_code": "dor"
        }
      ]
    },
    {
      "name": "直送",
      "order": 5,
      "short_code": "e",
      "sub_keyword": [
        {
          "name": "鮮直送",
          "order": 1,
          "short_code": "e1"
        },
        {
          "name": "日本直送",
          "order": 2,
          "short_code": "e2"
        },
        {
          "name": "韓國直送",
          "order": 3,
          "short_code": "e3"
        },
        {
          "name": "歐洲直送",
          "order": 4,
          "short_code": "e4"
        },
        {
          "name": "英國直送",
          "order": 5,
          "short_code": "e5"
        },
        {
          "name": "德國直送",
          "order": 6,
          "short_code": "e6"
        },
        {
          "name": "法國直送",
          "order": 7,
          "short_code": "e7"
        },
        {
          "name": "美國直送",
          "order": 8,
          "short_code": "e8"
        },
        {
          "name": "加拿大直送",
          "order": 9,
          "short_code": "e9"
        },
        {
          "name": "紐西蘭直送",
          "order": 10,
          "short_code": "e10"
        },
        {
          "name": "澳洲直送",
          "order": 11,
          "short_code": "e11"
        },
        {
          "name": "台灣直送",
          "order": 12,
          "short_code": "e12"
        },
        {
          "name": "其他",
          "order": 13,
          "short_code": "eor"
        }
      ]
    },
    {
      "name": "節日優惠",
      "order": 6,
      "short_code": "f",
      "sub_keyword": [
        {
          "name": "生日優惠",
          "order": 1,
          "short_code": "f1"
        },
        {
          "name": "周年優惠",
          "order": 2,
          "short_code": "f2"
        },
        {
          "name": "新年優惠",
          "order": 3,
          "short_code": "f3"
        },
        {
          "name": "情人節優惠",
          "order": 4,
          "short_code": "f4"
        },
        {
          "name": "復活節優惠",
          "order": 5,
          "short_code": "f5"
        },
        {
          "name": "母親節優惠",
          "order": 6,
          "short_code": "f6"
        },
        {
          "name": "父親節優惠",
          "order": 7,
          "short_code": "f7"
        },
        {
          "name": "暑假優惠",
          "order": 8,
          "short_code": "f8"
        },
        {
          "name": "開學優惠",
          "order": 9,
          "short_code": "f9"
        },
        {
          "name": "中秋節優惠",
          "order": 10,
          "short_code": "f10"
        },
        {
          "name": "萬聖節優惠",
          "order": 11,
          "short_code": "f11"
        },
        {
          "name": "感恩節",
          "order": 12,
          "short_code": "f12"
        },
        {
          "name": "黑色星期五",
          "order": 13,
          "short_code": "f13"
        },
        {
          "name": "聖誕節優惠",
          "order": 14,
          "short_code": "f14"
        },
        {
          "name": "禮物日優惠",
          "order": 15,
          "short_code": "f15"
        },
        {
          "name": "其他",
          "order": 16,
          "short_code": "for"
        }
      ]
    },
    {
      "name": "公司優惠",
      "order": 7,
      "short_code": "g",
      "sub_keyword": [
        {
          "name": "會員優惠",
          "order": 1,
          "short_code": "g1"
        },
        {
          "name": "迎新優惠",
          "order": 2,
          "short_code": "g2"
        },
        {
          "name": "其他",
          "order": 3,
          "short_code": "gor"
        }
      ]
    },
    {
      "name": "其他",
      "order": 8,
      "short_code": "h",
      "sub_keyword": [
        {
          "name": "批發",
          "order": 1,
          "short_code": "h1"
        },
        {
          "name": "聯乘",
          "order": 2,
          "short_code": "h2"
        },
        {
          "name": "獨家",
          "order": 3,
          "short_code": "h3"
        },
        {
          "name": "限量版",
          "order": 4,
          "short_code": "h4"
        },
        {
          "name": "特別版",
          "order": 5,
          "short_code": "h5"
        },
        {
          "name": "原創",
          "order": 6,
          "short_code": "h6"
        },
        {
          "name": "手工",
          "order": 7,
          "short_code": "h7"
        },
        {
          "name": "初創",
          "order": 8,
          "short_code": "h8"
        },
        {
          "name": "預購",
          "order": 9,
          "short_code": "h9"
        },
        {
          "name": "其他",
          "order": 10,
          "short_code": "hor"
        }
      ]
    }
  ]
}